import React from 'react';

// eslint-disable-next-line
export const EMAIL_CONFIG_TYPES_LABELS = {
  imap_smtp: 'IMAP/SMTP',
  imap_outlook: 'Outlook',
  google_oauth: 'Google',
};

export const EMAIL_IS_IN_USE_ERROR = 'Email is in use';
export const EMAIL_IS_IN_USE_NOTIFICATION = (
  <>
    Cannot delete or remove email address when it is used in an active campaign. Please deactivate your&nbsp;
    <a href="/campaigns">campaigns</a> first.
  </>
);
